import { render, staticRenderFns } from "./SystemTransactions.vue?vue&type=template&id=c9f2f4fc"
import script from "./SystemTransactions.vue?vue&type=script&lang=js"
export * from "./SystemTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports